var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOperationsActiveDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.491 1.66602H6.50768C3.47435 1.66602 1.66602 3.47435 1.66602 6.50768V13.4827C1.66602 16.5243 3.47435 18.3327 6.50768 18.3327H13.4827C16.516 18.3327 18.3243 16.5243 18.3243 13.491V6.50768C18.3327 3.47435 16.5243 1.66602 13.491 1.66602ZM6.39102 4.58268C6.39102 4.24102 6.67435 3.95768 7.01602 3.95768C7.35768 3.95768 7.64102 4.24102 7.64102 4.58268V7.83268C7.64102 8.17435 7.35768 8.45768 7.01602 8.45768C6.67435 8.45768 6.39102 8.17435 6.39102 7.83268V4.58268ZM7.9919 13.6659C7.79099 13.7617 7.64102 13.9525 7.64102 14.1751V15.416C7.64102 15.7577 7.35768 16.041 7.01602 16.041C6.67435 16.041 6.39102 15.7577 6.39102 15.416V14.1751C6.39102 13.9525 6.24101 13.7618 6.04019 13.6657C5.27545 13.3 4.74935 12.5256 4.74935 11.6243C4.74935 10.3743 5.76602 9.34935 7.01602 9.34935C8.26602 9.34935 9.29102 10.366 9.29102 11.6243C9.29102 12.5257 8.75843 13.3002 7.9919 13.6659ZM13.6077 15.416C13.6077 15.7577 13.3243 16.041 12.9827 16.041C12.641 16.041 12.3577 15.7577 12.3577 15.416V12.166C12.3577 11.8243 12.641 11.541 12.9827 11.541C13.3243 11.541 13.6077 11.8243 13.6077 12.166V15.416ZM12.9827 10.641C11.7327 10.641 10.7077 9.62435 10.7077 8.36602C10.7077 7.46468 11.2403 6.69015 12.0068 6.32448C12.2077 6.22864 12.3577 6.03782 12.3577 5.81522V4.58268C12.3577 4.24102 12.641 3.95768 12.9827 3.95768C13.3243 3.95768 13.6077 4.24102 13.6077 4.58268V5.82356C13.6077 6.04615 13.7577 6.23692 13.9585 6.33296C14.7232 6.6987 15.2493 7.47314 15.2493 8.37435C15.2493 9.62435 14.2327 10.641 12.9827 10.641Z",
    fill: "url(#paint0_linear_7035_124405)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7035_124405",
    x1: 9.9952,
    y1: 1.66602,
    x2: 9.9952,
    y2: 18.3327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsActiveDark);
export default __webpack_public_path__ + "static/media/operations-active-dark.5869660e755d71a7cb9f18abf9a618e1.svg";
export { ForwardRef as ReactComponent };